import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FlashMessageType } from '../ui/components/flash-messages/config';

export interface UIState {
  mobileNavOpen: boolean;
  isWithoutSidebar: boolean;
  isGalleryOpened: boolean;
  flashMessage: FlashMessageType | null;
}

const initialState: UIState = {
  mobileNavOpen: false,
  isWithoutSidebar: true,
  isGalleryOpened: false,
  flashMessage: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setNoSidebarLayoutStyle(state: UIState) {
      state.isWithoutSidebar = true;
    },
    setSidebarLayoutStyle(state: UIState) {
      state.isWithoutSidebar = false;
    },
    setGalleryState(state: UIState, action: PayloadAction<boolean>) {
      state.isGalleryOpened = action.payload;
    },
    setFlashMessage(state: UIState, action: PayloadAction<FlashMessageType>) {
      state.flashMessage = action.payload;
    },
    cleanFlashMessage(state: UIState) {
      state.flashMessage = null;
    },
  },
});

export const {
  setNoSidebarLayoutStyle,
  setSidebarLayoutStyle,
  setGalleryState,
  cleanFlashMessage,
  setFlashMessage,
} = uiSlice.actions;

export default uiSlice.reducer;
